import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Entity, EntityInterface } from '@proman/services/entity.service';
import { MenuService } from '@frontend/shared/services/menu.service';
import { routeMap } from '@frontend/shared/proman-route-map';
import { FaIcons } from '../../core/icons';
import { CurrUser } from '@proman/interfaces/object-interfaces';
import { Store } from '@ngrx/store';
import { getCurrUser } from '@proman/store/curr-user';

@Component({
    selector: 'pm-dashboard-hyperlink',
    template: `
        <pro-dialog-title title="click_you_want_to_add_menu_item"></pro-dialog-title>
        <div mat-dialog-content fxLayout="column">
          <mat-list>
            @for (item of Menu.items; track item) {
              <div>
                <mat-list-item (click)="handleClick(item)"
                  class="Clickable">
                  <div class="mat-list-item-text RightPadding">
                    <p>{{ item.name | translate }}</p>
                  </div>
                  @if (item.tabs.length) {
                    <fa
                      name="angle-down"
                      class="Rotate"
                      [ngClass]="{ 'is-rotated': item.isExpanded }"
                      (click)="handleClick(item)"
                    proClickStopPropagation></fa>
                  }
                </mat-list-item>
                @if (item.isExpanded) {
                  <div fxLayout="column"
                    class="ChildContainer"
                    >
                    <mat-list>
                      @for (tab of item.tabs; track tab) {
                        <mat-list-item
                          (click)="handle(tab, item)"
                          class="Clickable">
                          {{ tab.name | translate }}
                        </mat-list-item>
                      }
                    </mat-list>
                  </div>
                }
                <hr>
                </div>
              }
            </mat-list>
          </div>
          <pro-dialog-actions></pro-dialog-actions>
        `,
    styles: ['.ChildContainer { padding-left: 16px; }'],
    standalone: false
})

export class DashboardHyperlinkDialogComponent {
    data = inject(MAT_DIALOG_DATA);
    private store = inject(Store);
    Menu = inject(MenuService);
    private Entity = inject(Entity);
    private dialogRef = inject<MatDialogRef<DashboardHyperlinkDialogComponent>>(MatDialogRef);

    dashboardEntity: EntityInterface;
    currUser: CurrUser;

    constructor() {
        this.dashboardEntity = this.Entity.get('dashboard');
        this.store.select(getCurrUser)
            .subscribe((value) => this.currUser = value);
    }

    handle(item: any, parent: any) {
        (parent) ?
            this.add(item.state, parent.icon, item.name) :
            this.handleClick(item);

    };

    handleClick(item: any) {
        (item.tabs && item.tabs.length) ?
            item.isExpanded = !item.isExpanded :
            this.add(item.state, null, null);

    }

    add(state: any, icon: string, name: string) {
        this.dashboardEntity
            .create({
                config: JSON.stringify({
                    state: routeMap[state],
                    name
                }),
                icon: FaIcons[Math.floor(Math.random() * FaIcons.length)],
                owner: this.currUser.person.id,
                type: 'link'
            })
            .then(() => this.dialogRef.close());
    }

}
